import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "#444545",
  "stroke-linecap": "round",
  "stroke-width": "3",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M237.218 1.74H1.744V237.2h235.474z" }, null, -1),
    _createElementVNode("g", { "stroke-linecap": "butt" }, [
      _createElementVNode("path", { d: "M31.113 1.8v235.46M60.584 1.8v235.46M90.052 1.8v235.46M237.256 90.065c-81.246 0-147.068 65.819-147.068 147.06M237.256 119.53c-64.996 0-117.737 52.738-117.737 117.73m117.737-88.264c-48.746 0-88.269 39.52-88.269 88.264m88.27-58.934c-32.5 0-58.939 26.3-58.939 58.797m58.938-29.328c-16.249 0-29.467 13.217-29.467 29.465M119.52 1.8v147.197M148.85 1.8V119.53M178.321 1.8v100.52M207.79 1.8v91.293" })
    ], -1)
  ])))
}
export default { render: render }